customElements.component = 'collection-filters';

if (!customElements.get(customElements.component)) {
    class CollectionFilters extends HTMLElement {
        static isChromeBrowser(userAgent) {
            return /Chrome|CriOS/.test(userAgent);
        }

        static isFirefoxBrowser(userAgent) {
            return /Firefox|FxiOS/.test(userAgent);
        }

        static isUnsupportedVariant(userAgent) {
            return /(Edg|OPR|SamsungBrowser|YaBrowser|Vivaldi|Brave)/.test(userAgent);
        }

        static shouldUseDefaultPagination() {
            const userAgent = navigator.userAgent || '';
            return !CollectionFilters.isUnsupportedVariant(userAgent) &&
                (CollectionFilters.isChromeBrowser(userAgent) || CollectionFilters.isFirefoxBrowser(userAgent));
        }

        /**
         * Collection filters web component.
         *
         * @constructor
         */
        constructor() {
            super();
            this.paginationModes = {
                NUMERIC: 'numeric',
                LOAD_MORE: 'load-more'
            };
            this.paginationMode = CollectionFilters.shouldUseDefaultPagination()
                ? this.paginationModes.NUMERIC
                : this.paginationModes.LOAD_MORE;

            this.initEvents();
            this.initResetButton();
            this.loading = false;
            this.loader = null;
            this.productsCountEl = null;
            this.originalSearchParams = null;

            this.automaticApplyAvailabilityFilter = this.getAttribute("data-automatic-apply-availability-filter") === "true" ? true : false;

            window.addEventListener("DOMContentLoaded", () => {
                this.loader = document.querySelector('.collection .loader');
                this.productsCountEl = document.querySelector('[data-collection-products-count]');
                this.initFiltersCounter();
                this.keepActiveDropdownsOpen();
                this.updateSearchInputVisibility();
                this.storeOriginalSearchParams();
            })
        }

        initEvents() {
            this.syncPaginationControls();
            this.loadMoreButton = document.querySelector('.js-collection-load-more');

            this.querySelectorAll('[data-filter-submit]').forEach(submit => {
                submit.addEventListener('click', this.onInputChange.bind(this));
            });

            if (this.paginationMode === this.paginationModes.LOAD_MORE && this.loadMoreButton) {
                this.loadMoreButton.addEventListener('click', this.loadMore.bind(this));
            } else if (this.paginationMode === this.paginationModes.LOAD_MORE) {
                window.addEventListener('scroll', this.onWindowScroll.bind(this));
            }
        }

        syncPaginationControls() {
            const loadMoreContainer = document.querySelector('.collection__load-more');
            const loadMoreButton = document.querySelector('.js-collection-load-more');
            const numericPagination = document.querySelector('.js-collection-pagination');

            if (this.paginationMode === this.paginationModes.NUMERIC) {
                if (loadMoreContainer) {
                    loadMoreContainer.classList.add('hidden');
                }
                if (loadMoreButton) {
                    loadMoreButton.classList.add('hidden');
                    loadMoreButton.setAttribute('aria-hidden', 'true');
                    loadMoreButton.disabled = true;
                }
                if (numericPagination) {
                    numericPagination.classList.remove('hidden');
                }
                return;
            }

            if (loadMoreContainer) {
                loadMoreContainer.classList.remove('hidden');
            }
            if (loadMoreButton) {
                loadMoreButton.classList.remove('hidden');
                loadMoreButton.removeAttribute('aria-hidden');
                loadMoreButton.disabled = false;
            }
            if (numericPagination) {
                numericPagination.classList.add('hidden');
            }
        }

        onInputChange() {
            this.initRender();
        }

        async updateButtonCounters(responseLayout = null) {
            const nextUrl = document.querySelector('.js-collection-load-more')?.dataset.nextUrl;
            const collectionTotalProductsCount = document.querySelector('.collection-total-products-count');
            const gridItems = document.querySelectorAll('#main-collection-product-grid .product-grid__item');
            const collectionCurrentProductsCount = document.querySelector('.collection-current-products-count');
            if (!nextUrl) {
                return;
            }
            const responseNextPage = await fetch(nextUrl);
            const responseNextPageLayout = new DOMParser().parseFromString(await responseNextPage.text(), 'text/html');

            if (collectionTotalProductsCount && responseLayout) {
                collectionTotalProductsCount.innerHTML = +responseLayout.querySelector('filter-count').innerText.trim().split(' ')[0] - gridItems.length;
            }

            collectionCurrentProductsCount.innerHTML = +responseNextPageLayout.querySelectorAll('#main-collection-product-grid .product-grid__item').length;
        }

        async initFiltersCounter() {
            if (window.location.pathname.includes('search')) {
              return
            }

            if (this.paginationMode === this.paginationModes.NUMERIC) {
              return;
            }

            try {
              const collectionCounter = document.querySelector('#CollectionFilterCounter');
              const urlParams = new URLSearchParams(window.location.search);
              urlParams.delete('sort_by');
              urlParams.delete('page');
              const filterCountUrl = `${window.location.pathname}?section_id=filter-count&${urlParams.toString()}`;
              const response = await fetch(filterCountUrl);
              const responseLayout = new DOMParser().parseFromString(await response.text(), 'text/html');

              collectionCounter.innerHTML = responseLayout.querySelector('filter-count').innerHTML;

              await this.updateButtonCounters(responseLayout);
            } catch (error) {
              console.error(error);
            }
          }

        async loadMore() {
            this.loading = true;
            const grid = document.querySelector('#main-collection-product-grid');

            if (this.loadMoreButton && +grid.dataset.page +1 >= +grid.dataset.maxPage) {
                this.loadMoreButton.classList.add('hidden');
            }

            if (parseInt(grid.dataset.page) >= parseInt(grid.dataset.maxPage)) {
                this.loading = false;
                return;
            }

            let page = parseInt(grid.dataset.page) + 1;
            let url;
            if (document.URL.includes('?')) {
                url = `${document.URL}&page=`
            } else {
                url = `${window.location.pathname}?page=`
            }

            await fetch(url + page, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.text())
                .then(data => {
                    const parser = new DOMParser();
                    const newContent = parser.parseFromString(data, 'text/html').body;
                    const loadMoreButton = document.querySelector('.js-collection-load-more');
                    const newContentNextUrl = newContent.querySelector('.js-collection-load-more')?.dataset.nextUrl;

                    if (loadMoreButton) {
                        loadMoreButton.dataset.nextUrl = newContentNextUrl;
                    }

                    newContent.querySelectorAll('[data-loadmore-item]').forEach(productCard => {
                        grid.appendChild(productCard);
                    })

                    grid.dataset.page = page;
                    this.productsCountEl ? this.productsCountEl.textContent = grid.querySelectorAll(".product-grid__item").length : '';
                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error fetching products:', error);
                    this.loading = false;
                });

            if (this.loadMoreButton) {
                const collectionCurrentProductsCount = document.querySelector('.collection-current-products-count');
                const productsSize = document.querySelector('.collection-total-products-count');

                productsSize.innerHTML = +productsSize.innerHTML - collectionCurrentProductsCount.innerHTML;

                await this.updateButtonCounters();
            }
        }

        getParamsFromForm(form) {
            const formData = new FormData(form);

            if (this.automaticApplyAvailabilityFilter) {
                if (formData.getAll("filter.v.option.size").length) {
                    formData.set("filter.v.availability", "1");
                } else {
                    formData.delete("filter.v.availability");
                }
            }

            return new URLSearchParams(formData).toString();
        }

        initRender() {
            this.loader = document.querySelector('.collection .loader');
            this.loader && this.loader.classList.add("visible");
            const searchParams = this.getParamsFromForm(document.querySelector('#CollectionFiltersForm'));
            const url = `${window.location.pathname}?${searchParams}`;

            const grid = document.querySelector('#main-collection-product-grid');
            if (grid) {
                grid.dataset.page = '1';
            }

            this.renderPage(url, searchParams);
        }

        storeOriginalSearchParams() {
            if (window.location.pathname.includes('search')) {
                const urlParams = new URLSearchParams(window.location.search);
                const originalParams = new URLSearchParams();

                for (const [key, value] of urlParams) {
                    if (!key.startsWith('filter.') &&
                        !key.startsWith('filter_') &&
                        !key.startsWith('filter[') &&
                        key !== 'page' &&
                        key !== 'sort_by') {
                        originalParams.set(key, value);
                    }
                }

                this.originalSearchParams = originalParams.toString();
            }
        }

        resetFilters() {
            this.clearFilterCheckboxes();

            if (window.location.pathname.includes('search')) {
                if (this.originalSearchParams) {
                    const newUrl = `${window.location.pathname}?${this.originalSearchParams}`;
                    this.renderPage(newUrl, this.originalSearchParams);
                } else {
                    const urlParams = new URLSearchParams(window.location.search);
                    const preservedParams = new URLSearchParams();

                    for (const [key, value] of urlParams) {
                        if (!key.startsWith('filter.') &&
                            !key.startsWith('filter_') &&
                            !key.startsWith('filter[') &&
                            key !== 'page' &&
                            key !== 'sort_by') {
                            preservedParams.set(key, value);
                        }
                    }

                    const preservedQueryString = preservedParams.toString();
                    const newUrl = preservedQueryString ?
                        `${window.location.pathname}?${preservedQueryString}` :
                        window.location.pathname;

                    this.renderPage(newUrl, preservedQueryString);
                }
            } else {
                this.renderPage(window.location.pathname, "");
            }
        }

        clearFilterCheckboxes() {
            const checkboxes = document.querySelectorAll('#CollectionFiltersForm input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });

            const numberInputs = document.querySelectorAll('#CollectionFiltersForm input[type="number"]');
            numberInputs.forEach(input => {
                input.value = '';
            });

            const activeFilterItems = document.querySelectorAll('[data-filter-group] li.selected');
            activeFilterItems.forEach(item => {
                item.classList.remove('selected');
            });
        }

        updateFilterDrawer(html) {
            const newDocument = new DOMParser().parseFromString(html, 'text/html');
            const newFilterForm = newDocument.querySelector('#CollectionFiltersForm');
            const currentFilterForm = document.querySelector('#CollectionFiltersForm');

            if (newFilterForm && currentFilterForm) {
                currentFilterForm.innerHTML = newFilterForm.innerHTML;
                this.keepActiveDropdownsOpen();
            }
        }

        keepActiveDropdownsOpen() {
            const detailsElements = document.querySelectorAll('#CollectionFiltersForm details');

            detailsElements.forEach(details => {
                const checkedCheckboxes = details.querySelectorAll('input[type="checkbox"]:checked');
                const filledNumberInputs = details.querySelectorAll('input[type="number"]:not([value=""])');

                if (checkedCheckboxes.length > 0 || filledNumberInputs.length > 0) {
                    details.open = true;
                }
            });
        }

        renderPage(url, searchParams) {
            window.scrollTo(0, 130);

            fetch(url)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = responseText;
                    this.updateURLHash(searchParams);
                    this.renderGrid(html);
                    this.updateFilterDrawer(html);
                    this.initResetButton();
                    this.initFiltersCounter();
                });
        }

        renderGrid(html) {
            const newDocument = new DOMParser().parseFromString(html, 'text/html');
            const newGrid = newDocument.querySelector('#main-collection-product-grid');
            const noProducts = document.querySelector('.js-collection-no-products');
            const newNoProducts = newDocument.querySelector('.js-collection-no-products');
            const currentGrid = document.querySelector('#main-collection-product-grid');
            const collectionSeo = document.querySelector('.collection__seo');

            this.updateFilterCheckboxes(newDocument);

            if (newGrid && currentGrid) {
                currentGrid.innerHTML = newGrid.innerHTML;
                currentGrid.dataset.page = newGrid.dataset.page;
                currentGrid.dataset.maxPage = newGrid.dataset.maxPage;
                currentGrid.classList.remove('hidden');
                if (collectionSeo) collectionSeo.classList.remove('hidden');
                if (noProducts) noProducts.classList.add('hidden');
            }

            if (newNoProducts) {
                if (noProducts) {
                    noProducts.remove();
                }

                const container = currentGrid ? currentGrid.parentNode : document.querySelector('#CollectionProductGrid');
                if (container) {
                    container.appendChild(newNoProducts);
                }

                if (currentGrid) currentGrid.classList.add('hidden');
                if (collectionSeo) collectionSeo.classList.add('hidden');

                this.hidePagination();
            } else {
                this.showPagination();
            }

            const newCounter = newDocument.querySelector('#CollectionFilterCounter');

            if (newCounter && window.location.pathname.includes('search')) {
                document.querySelector('#CollectionFilterCounter').innerHTML = newCounter.innerHTML;
            }

            this.updateSearchCount(html);

            this.loader && this.loader.classList.remove("visible");

            this.keepActiveDropdownsOpen();
            this.updateSearchInputVisibility();
            this.syncPaginationControls();
        }

        updateFilterCheckboxes(newDocument) {
            const newCheckboxes = newDocument.querySelectorAll('#CollectionFiltersForm input[type="checkbox"]');

            newCheckboxes.forEach(newCheckbox => {
                const currentCheckbox = document.querySelector(`#CollectionFiltersForm input[name="${newCheckbox.name}"][value="${newCheckbox.value}"]`);
                if (currentCheckbox) {
                    currentCheckbox.checked = newCheckbox.checked;
                }
            });

            const newActiveItems = newDocument.querySelectorAll('[data-filter-group] li.selected');
            const currentActiveItems = document.querySelectorAll('[data-filter-group] li.selected');

            currentActiveItems.forEach(item => {
                item.classList.remove('selected');
            });

            newActiveItems.forEach(newItem => {
                const group = newItem.parentNode.parentNode.dataset.filterGroup;
                const value = newItem.querySelector('[data-filter-list-option-link]')?.textContent?.trim();

                if (group && value) {
                    const currentItem = document.querySelector(`[data-filter-group="${group}"] [data-filter-list-option-link]:contains("${value}")`)?.parentNode;
                    if (currentItem) {
                        currentItem.classList.add('selected');
                    }
                }
            });
        }

        updateSearchInputVisibility() {
            if (!window.location.pathname.includes('search')) {
                return;
            }

            const searchInputContainer = document.querySelector('.search-page .w-full.md\\:w-1\\/2.md\\:mx-auto');
            const noProductsElement = document.querySelector('.js-collection-no-products');
            const productGrid = document.querySelector('#main-collection-product-grid');

            if (searchInputContainer) {
                if (noProductsElement && !noProductsElement.classList.contains('hidden')) {
                    searchInputContainer.classList.remove('hidden');
                } else if (productGrid && productGrid.querySelectorAll('.product-grid__item').length === 0) {
                    searchInputContainer.classList.remove('hidden');
                } else {
                    searchInputContainer.classList.add('hidden');
                }
            }
        }

        updateSearchCount(html) {
            if (!window.location.pathname.includes('search')) {
                return;
            }

            const newDocument = new DOMParser().parseFromString(html, 'text/html');
            const newSearchCount = newDocument.querySelector('.js-search-count');
            const currentSearchCount = document.querySelector('.js-search-count');

            if (newSearchCount && currentSearchCount) {
                currentSearchCount.textContent = newSearchCount.textContent;
            }
        }

        hidePagination() {
            const pagination = document.querySelector('.pagination');
            const searchFooter = document.querySelector('.search__footer');

            if (pagination) {
                pagination.style.display = 'none';
            }
            if (searchFooter) {
                searchFooter.style.display = 'none';
            }
        }

        showPagination() {
            const pagination = document.querySelector('.pagination');
            const searchFooter = document.querySelector('.search__footer');

            if (pagination) {
                pagination.style.display = '';
            }
            if (searchFooter) {
                searchFooter.style.display = '';
            }
        }

        updateURLHash(searchParams) {
            history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
        }

        initResetButton() {
            const resetButton = document.querySelector("#resetFilters");
            const resetButtonMobile = document.querySelector('[data-filter-reset]');

            if (resetButton) {
                resetButton.removeEventListener("click", this.resetFilters);
                resetButton.addEventListener("click", () => this.resetFilters());
            }
            if (resetButtonMobile) {
                resetButtonMobile.removeEventListener("click", this.resetFilters);
                resetButtonMobile.addEventListener("click", () => this.resetFilters());
            }
        }
    }

    customElements.define('collection-filters', CollectionFilters);
}
